import { render, staticRenderFns } from "./Herder.vue?vue&type=template&id=22c7175b&scoped=true&"
import script from "./Herder.vue?vue&type=script&lang=js&"
export * from "./Herder.vue?vue&type=script&lang=js&"
import style0 from "./Herder.vue?vue&type=style&index=0&id=22c7175b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7175b",
  null
  
)

export default component.exports